import { Tab, TabSize, useStrategiesContext } from '@talos/kyoko';
import { useCallback } from 'react';
import type { PreTradeResponseData } from '../../redux/preTradeApi';
import { formatScenarioLabel, formatScenarioName } from '../../utils';
import { ScenarioChipContainer, TabWrapper } from './styles';

interface ScenarioChipProps {
  scenario: PreTradeResponseData;
  index: number;
  isActive: boolean;
  onSelect: (index: number) => void;
  onClose?: (index: number) => void;
}

export function ScenarioChip({ scenario, index, isActive, onSelect, onClose }: ScenarioChipProps) {
  const { strategiesByName } = useStrategiesContext();
  const chipText = formatScenarioLabel(index + 1, formatScenarioName(scenario, strategiesByName));

  const handleSelect = useCallback(() => onSelect(index), [onSelect, index]);
  const handleClose = useCallback(() => onClose?.(index), [onClose, index]);

  return (
    <ScenarioChipContainer>
      <TabWrapper $isSelected={isActive}>
        <Tab
          label={chipText}
          isSelected={isActive}
          onClick={handleSelect}
          size={TabSize.Default}
          closable={!!onClose}
          onRemove={handleClose}
          data-testid={`scenario-tab-${index}`}
        />
      </TabWrapper>
    </ScenarioChipContainer>
  );
}
